/* eslint-disable import/no-cycle */
import React from "react";

import { Box, CardContent, Typography, useTheme } from "@mui/material";

import ActionsList from "./ActionsList";
import InsightsModalManager, {
  ModalType,
} from "../../../../common/ModalManager";
import { Category } from "../../../../common/types";
import formatWord from "../../../../../utils/formatWord";
import InsightCardShell from "./InsightCardShell";

interface TitleProp {
  title: string;
  titles: string[];
  category: Category;
  refetch?: () => void;
}

export default function Title({ title, titles, category, refetch }: TitleProp) {
  const [openInsightsModalManager, setOpenInsightsModalManager] =
    React.useState(false);
  const theme = useTheme();

  const handleOpenInsightsModalManager = () =>
    setOpenInsightsModalManager(true);

  const handleCopy = () => {
    navigator.clipboard.writeText(title);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <InsightsModalManager
        open={openInsightsModalManager}
        setOpen={setOpenInsightsModalManager}
        modalType={ModalType.TITLES}
        modalTitle={`Edit ${formatWord(category)}`}
        category={category}
        objectValue={{ title }}
        values={titles}
        refetch={refetch || (() => {})}
      />

      <InsightCardShell
        sx={{
          p: 1.75,
          mb: 1.5,
        }}
      >
        <CardContent sx={{ p: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1.5,
            }}
          >
            {/* Title Text */}
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                lineHeight: 1.3,
                color: theme.palette.text.primary,
                fontSize: "0.9rem",
                flex: 1,
                wordBreak: "break-word",
              }}
            >
              {title}
            </Typography>

            {/* Action Buttons */}
            <ActionsList
              handleOpenInsightsModalManager={handleOpenInsightsModalManager}
              handleCopy={handleCopy}
            />
          </Box>
        </CardContent>
      </InsightCardShell>
    </Box>
  );
}
